export default "__VITE_ASSET__cd0a5dcf__"